import React from 'react';
import { Tooltip } from '@chakra-ui/react';

export const formatNumber = (num, digits = 2) => {
    if (num === null || num === undefined) return '0';
    const n = Number(num);
    if (isNaN(n)) return '0';
    
    const absN = Math.abs(n);
    const sign = n < 0 ? '-' : '';
    
    // For very large numbers
    if (absN >= 1000000) return sign + parseFloat((absN / 1000000).toFixed(digits)).toString() + 'M';
    if (absN >= 1000) return sign + parseFloat((absN / 1000).toFixed(digits)).toString() + 'k';
    
    // For regular numbers
    return sign + parseFloat(absN.toFixed(digits)).toString();
};

export const getExactNumber = (num, digits = 2) => {
    if (num === null || num === undefined) return '0';
    const n = Number(num);
    if (isNaN(n)) return '0';
    return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits
    }).format(n);
};

function FormattedNumber({ value, digits = 2, prefix = '', suffix = '' }) {
    const formatted = formatNumber(value, digits);
    const n = Number(value);
    
    // If number is valid and >= 1000, wrap in tooltip, else just return the string
    if (!isNaN(n) && (n >= 1000 || n <= -1000)) {
        const exact = getExactNumber(value, digits);
        return (
            <Tooltip label={`${prefix}${exact}${suffix}`} placement="top" hasArrow bg="gray.800" color="white" fontSize="xs" borderRadius="md">
                <span style={{ cursor: 'help' }}>{prefix}{formatted}{suffix}</span>
            </Tooltip>
        );
    }

    return <>{prefix}{formatted}{suffix}</>;
}

export default FormattedNumber;
